import client from './client'

export const getFilterOptions = async () => {
  try {
    const response = await client.get('/lens/browse/filter-options')
    return response
  } catch (err) {
    console.error(err)
    const { response } = err

    if (response?.data && Object.keys(response.data).length > 0) return response.data

    return { error: err.message || err }
  }
}
